const amplitudeDashboardRoutes = [
    {
        path: '/amplitude-dashboard',
        name: 'amplitudeDashboardRoot',
        meta: {
            auth: true,
            resource: 'amplitude_dashboard',
            action: 'view'
        },
        children: [
            {
                path: '',
                name: 'amplitudeDashboard',
                component: () => import('@/modules/amplitude_dashboard/Dashboard.vue'),
                meta: {
                    resource: 'amplitude_dashboard',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Amplitude',
                    breadcrumbs: [
                        { title: 'App Analytics', routeName: 'amplitudeDashboard' },
                        { title: 'Amplitude', routeName: 'amplitudeDashboard' }
                    ]
                }
            }
        ]
    }
]

export default amplitudeDashboardRoutes
